import React from "react";
import UpcomingServicesPage from "@pages/UpcomingServices/UpcomingServicesPage";
import UpcomingServiceEditorPage from "@pages/UpcomingServices/UpcomingServiceEditorPage";
import ProtectedRoute from "@components/routes/ProtectedRoute";
import RsvpPage from "@pages/Memorials/RsvpPage";

export default [
    {
        path: "upcoming-services",
        element: <ProtectedRoute allowedRoles={["root_admin", "business_admin", "business_user", "demo"]} />,
        children: [
            {
                path: "",
                element: <UpcomingServicesPage />,
            },
            {
                path: "editor",
                element: <UpcomingServiceEditorPage />,
            },
            {
                path: "rsvps",
                element: <RsvpPage />,
            },
        ],
    },
];
